import "./Nftshowcase.css";
const ShareButton = ({ message }) => {
    const tweet = encodeURIComponent(message);
    const shareUrl = `https://twitter.com/intent/tweet?text=${tweet}`;
  
return (
    <a href={shareUrl} target="_blank" rel="noopener noreferrer" className="twitter-share-button">
    Share on Twitter
  </a>
  
    );
  };
  
  export default ShareButton;
  